import React from 'react';
import ResetPassword from '@features/auth/components/reset-password/ResetPassword';

const ResetPasswordPage: React.FC = () => {
  return <ResetPassword />;
};

export default ResetPasswordPage;